export default function CreateMultipleUserCtrl(
  AlertService,
  Authentication,
  PersonaCollection,
  previousState,
  $state
) {
  'ngInject';

  const controller = this;

  controller.positions = PersonaCollection.positions;
  controller.isUserUnverified = Authentication.user.status === 'unverified';
  controller.previousState = previousState;
  controller.userCountryCode = Authentication.user.countryCode;
  controller.userCountryISOCode = Authentication.user.countryISOCode;

  Object.defineProperty(controller, 'locations', {
    get() {
      return Authentication.user.isAdmin
        ? PersonaCollection.locations
        : PersonaCollection.me.locations;
    },
  });

  controller.onSuccess = async function onSuccess() {
    PersonaCollection.refresh();
    await AlertService.success('Successfully saved new employees', null, 1500);
    $state.go('dashboard.manage.users.list');
  };

  controller.onCancel = function onCancel() {
    $state.go('dashboard.manage.users.list');
  };

  controller.onError = function onError(errorMessage) {
    AlertService.danger(errorMessage);
  };
}
